import { Checkbox } from '../../../../../../../../components/checkbox/checkbox';
import { pushNotificationKey } from '../../../../../../../../helpers/local-storage';
import { swPath } from '../../../../../../../../helpers/path';
import { getPushState } from '../../../../../../../../helpers/validate';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useLocalStorageSubscribe } from '../../../../../../../../hooks/use-local-storage-subscribe';
import { useAlertStore } from '../../../../../../../../store/use-alert-store';
import { ProfileSettingsLabel } from '../profile-settings-label/profile-settings-label';

export const ProfileSettingsPush = () => {
  const { t } = useLang();

  const { handleChange } = useLocalStorageSubscribe();
  const { add } = useAlertStore();
  const isPushEnabled = getPushState();

  const onCheckPush = async () => {
    if (isPushEnabled) {
      localStorage.removeItem(pushNotificationKey);
      handleChange();
    } else {
      const userConfirmed = window.confirm(
        t('Мы хотим отправлять вам уведомления о важных событиях. Разрешить уведомления?'),
      );
      if (userConfirmed) {
        const sw = await navigator.serviceWorker.getRegistration(swPath);
        if (!sw) {
          add({
            label: t('Ошибка'),
            children: t('Дождитесь активации уведомлений'),
            variant: 'info',
          });
          return;
        }

        const resp = await Notification.requestPermission();
        if (resp === 'granted') {
          localStorage.setItem(pushNotificationKey, 'true');
          handleChange();
          sw.showNotification(t('Изменение настроек'), {
            body: t('Push-уведомления включены'),
          });
        } else {
          console.error('Пользователь отклонил push-уведомления');
        }
      }
    }
  };

  const isNotificationsAvailable = 'Notification' in window;

  if (!isNotificationsAvailable) {
    return <span>{t('Ваш браузер не поддерживает уведомления')}</span>;
  }

  return (
    <ProfileSettingsLabel
      label={t('Push Уведомления')}
      subLabel={t('Контролируйте уведомления в вашем браузере')}
    >
      <Checkbox
        label={t('Отправлять мне push уведомдения')}
        subLabel={t('Включить отправку мне уведомлений в браузере от системы')}
        onClick={onCheckPush}
        checked={isPushEnabled}
      />
    </ProfileSettingsLabel>
  );
};
